const { createSelector } = require('reselect')

const selectCouponList = state => state.couponDomain.coponList

const getCouponList = () => createSelector(
  [selectCouponList],
  cse => cse.data,
)

const getCouponListError = () => createSelector(
  [selectCouponList],
  cse => cse.error,
)

const getCouponListLoading = () => createSelector(
  [selectCouponList],
  cse => cse.loading,
)

const selectCoupon = state => state.couponDomain.copon

const getCoupon = () => createSelector(
  [selectCoupon],
  cse => cse.data,
)

const getCouponError = () => createSelector(
  [selectCoupon],
  cse => cse.error,
)

const getCouponLoading = () => createSelector(
  [selectCoupon],
  cse => cse.loading,
)

const selectCreate = state => state.couponDomain.create

const getCreateCoupon = () => createSelector(
  [selectCreate],
  cse => cse.data,
)

const getCreateCouponError = () => createSelector(
  [selectCreate],
  cse => cse.error,
)

const getCreateCouponLoading = () => createSelector(
  [selectCreate],
  cse => cse.loading,
)
const selectUpdate = state => state.couponDomain.update

const getUpdateCoupon = () => createSelector(
  [selectUpdate],
  cse => cse.data,
)

const getUpdateCouponError = () => createSelector(
  [selectUpdate],
  cse => cse.error,
)

const getUpdateCouponLoading = () => createSelector(
  [selectUpdate],
  cse => cse.loading,
)
const selectDelete = state => state.couponDomain.delete

const getDeleteCoupon = () => createSelector(
  [selectDelete],
  cse => cse.data,
)

const getDeleteCouponError = () => createSelector(
  [selectDelete],
  cse => cse.error,
)

const getDeleteCouponLoading = () => createSelector(
  [selectDelete],
  cse => cse.loading,
)

const selectAlert = state => state.couponDomain.coupon

const coupon = () => createSelector(
  [selectAlert],
  alert => alert.data,
)

const couponError = () => createSelector(
  [selectAlert],
  alert => alert.error,
)

const couponLoading = () => createSelector(
  [selectAlert],
  alert => alert.loading,
)

module.exports = {
  getCouponList,
  getCouponListLoading,
  getCouponListError,
  getCoupon,
  getCouponLoading,
  getCouponError,
  getCreateCoupon,
  getCreateCouponLoading,
  getCreateCouponError,
  getUpdateCoupon,
  getUpdateCouponLoading,
  getUpdateCouponError,
  getDeleteCoupon,
  getDeleteCouponLoading,
  getDeleteCouponError,
  coupon,
  couponError,
  couponLoading,
}
